import { CycleDetailHeading } from "@domains/reviews/client/components/cycles/detail/CycleDetailHeading.tsx";
import { cycleOriginPath } from "@domains/reviews/client/components/cycles/cycleDetailPaths.ts";
import { resolveCycleFormTargets } from "@domains/reviews/client/components/cycles/cycleFormTargets.ts";
import { hasAnyRole } from "@packages/core/session/roles.ts";
import { PERFORMANCE_CYCLES_ACCESS } from "@packages/core/access/settingsAccess.ts";
import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import { useEnvironmentVariable, useFeatureFlags } from "@squide/firefly";
import { useI18nextInstance } from "@squide/i18next";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMatches, useNavigate } from "react-router";
import { i18NextInstanceKey } from "../../../i18n/i18next.ts";

const ORG_CYCLES_LIST_PATH = cycleOriginPath("org");

export function ReviewCycleDetailHeading() {
    const i18nextInstance = useI18nextInstance(i18NextInstanceKey);
    const { t } = useTranslation("ReviewCycleDetailHeading", { i18n: i18nextInstance });
    const featureFlags = useFeatureFlags();
    const session = useSession();
    const navigate = useNavigate();
    const workleapPerformanceUrl = useEnvironmentVariable("workleapPerformanceUrl");

    const matches = useMatches();
    const cycleId = matches[matches.length - 1]?.params?.cycleId ?? "";

    const ancestorCrumbs = useMemo(() => [{ label: t("cyclesList"), href: ORG_CYCLES_LIST_PATH }], [t]);

    const isBuilderEnabled = featureFlags?.["review-cycle-builder"] ?? false;

    const cycleForm = useMemo(() => resolveCycleFormTargets({ origin: "settings", isBuilderEnabled, workleapPerformanceUrl }), [isBuilderEnabled, workleapPerformanceUrl]);

    const handleLeaveCycle = useCallback(() => navigate(ORG_CYCLES_LIST_PATH, { replace: true }), [navigate]);

    if (!cycleId) {
        return null;
    }

    return (
        <div className="-mt-4 w-full">
            <CycleDetailHeading cycleId={cycleId} ancestorCrumbs={ancestorCrumbs} canAdministerCycles={hasAnyRole(session, PERFORMANCE_CYCLES_ACCESS)} getEditCycleHref={cycleForm.getEditHref} isEditInApp={cycleForm.isInApp} onCycleDeleted={handleLeaveCycle} onCycleNotViewable={handleLeaveCycle} />
        </div>
    );
}
